import {
  FoldOptionLeft,
  FoldOptionRight,
  LeftFold,
  RightFold,
  TopFoldHeaderContainer,
} from '@/components/general/TopFold';

type Props = {
  mode: 'FOLD' | 'reFOLD';
  setMode: (mode: 'FOLD' | 'reFOLD') => void;
  subMode: 'Stake' | 'Unstake' | 'Convert';
  setSubMode: (subMode: 'Stake' | 'Unstake' | 'Convert') => void;
};
function FoldTopFold({ mode, setMode, subMode, setSubMode }: Props) {
  return (
    <TopFoldHeaderContainer>
      <LeftFold>
        <FoldOptionLeft
          onClick={() => {
            setSubMode('Stake');
            setMode('FOLD');
          }}
          selected={mode === 'FOLD'}
        >
          FOLD
        </FoldOptionLeft>
        <FoldOptionLeft
          onClick={() => {
            setSubMode('Convert');
            setMode('reFOLD');
          }}
          selected={mode === 'reFOLD'}
        >
          reFOLD
        </FoldOptionLeft>
      </LeftFold>
      <RightFold>
        {mode === 'FOLD' ? (
          <>
            <FoldOptionRight onClick={() => setSubMode('Stake')} selected={subMode === 'Stake'}>
              Stake
            </FoldOptionRight>
            <FoldOptionRight onClick={() => setSubMode('Unstake')} selected={subMode === 'Unstake'}>
              Unstake
            </FoldOptionRight>
          </>
        ) : (
          <FoldOptionRight onClick={() => setSubMode('Convert')} selected={subMode === 'Convert'}>
            Convert
          </FoldOptionRight>
        )}
      </RightFold>
    </TopFoldHeaderContainer>
  );
}

export default FoldTopFold;
